(function() {
  'use strict';

  function initializeCartDrawer() {
    if (
      !window.theme ||
      !theme.settings ||
      theme.settings.cartType !== 'drawer' ||
      document.body.classList.contains('template-cart') ||
      !document.getElementById('CartDrawer') ||
      typeof theme.CartDrawer !== 'function'
    ) {
      return;
    }

    if (!theme.tbsCartDrawer) {
      theme.tbsCartDrawer = new theme.CartDrawer();
    }
  }

  function showBuyNowError(form, message) {
    var existingErrors = form.querySelector('.errors');

    if (existingErrors) {
      existingErrors.remove();
    }

    var errorDiv = document.createElement('div');
    errorDiv.className = 'errors text-center';
    errorDiv.textContent = message || 'This product could not be added to the cart.';
    form.prepend(errorDiv);
  }

  function handleBuyNowClick(event) {
    var button = event.target.closest('[data-tbs-buy-now]');

    if (!button || button.disabled) {
      return;
    }

    var form = button.closest('form[action*="/cart/add"]');
    var addToCartButton = form ? form.querySelector('[data-add-to-cart]') : null;

    if (!form || !window.theme || !theme.routes || !theme.routes.cartAdd) {
      return;
    }

    event.preventDefault();

    if (addToCartButton && addToCartButton.disabled) {
      return;
    }

    button.disabled = true;
    button.classList.add('btn--loading');

    fetch(theme.routes.cartAdd, {
      method: 'POST',
      body: new FormData(form),
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function(response) {
        return response.json().then(function(data) {
          return {
            ok: response.ok,
            data: data
          };
        });
      })
      .then(function(result) {
        if (!result.ok || result.data.status === 422) {
          throw new Error(result.data.description || result.data.message);
        }

        window.location.assign('/checkout');
      })
      .catch(function(error) {
        showBuyNowError(form, error.message);
        button.disabled = false;
        button.classList.remove('btn--loading');
      });
  }

  function initialize() {
    initializeCartDrawer();
    document.addEventListener('click', handleBuyNowClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();
